import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Icon from '../../atoms/Icon'

/**
 * Represents an individual activity item that is non-specific
 * @param activity
 * @param onClick
 * @param className
 * @param style
 * @returns {JSX.Element}
 * @constructor
 */
function Activity ({ activity, onClick, className, style }) {
  return (
    <div className={clsx(className, 'flex flex-row gap-sm clickable')} style={style} onClick={onClick}>
      <div>
        <Icon name={activity.completed ? 'checkCircle' : 'clock'} style={{ fill: activity.completed ? 'var(--color-success-500)' : 'var(--color-warning-500)' }} />
      </div>
      <div>
        {activity.subject}
      </div>
    </div>
  )
}

Activity.propTypes = {
  activity: PropTypes.shape({
    subject: PropTypes.string,
    completed: PropTypes.bool
  }).isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object
}

export default Activity
